var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02847 21.1711C10.8991 25.0877 17.2537 25.1252 21.1704 21.2546C25.087 17.3839 25.1244 11.0292 21.2538 7.11268C17.3833 3.19618 11.0284 3.15868 7.11193 7.02921C3.19544 10.8997 3.15794 17.2546 7.02847 21.1711ZM20.3301 8.02556C23.7078 11.4433 23.6753 16.9532 20.2575 20.3308C16.8397 23.7085 11.3299 23.676 7.9522 20.2582C4.57452 16.8404 4.60704 11.3306 8.02482 7.95294C11.4426 4.57526 16.9524 4.60778 20.3301 8.02556Z",
    fill: "#0078E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07315 14.1122C9.07206 14.2959 9.1446 14.4433 9.27234 14.5726C9.4002 14.7019 9.54671 14.7762 9.73029 14.7772L13.4956 14.7812L13.4733 18.5646C13.4722 18.7483 13.5447 18.8957 13.6725 19.0249C13.8003 19.1543 13.9468 19.2286 14.1304 19.2296C14.4979 19.2317 14.7934 18.9397 14.7771 18.5905L14.7814 14.7888L18.5648 14.8111C18.9322 14.8133 19.2277 14.5212 19.2115 14.172C19.2136 13.8046 18.9216 13.5091 18.5724 13.5253L14.789 13.503L14.8113 9.71961C14.8135 9.35218 14.5214 9.05667 14.1722 9.07293C13.8048 9.07076 13.5093 9.3628 13.5255 9.71202L13.5032 13.4954L9.71979 13.4731C9.37104 13.4527 9.07542 13.7449 9.07311 14.1122L9.07315 14.1122Z",
    fill: "#0078E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddValue);
export default __webpack_public_path__ + "static/media/add-value.1ac1944055e6bce19c943b46ba149658.svg";
export { ForwardRef as ReactComponent };